import { useState } from 'react';
import EventModal from '../modals/EventModal';
import Modal from './Modal';
import { requestOrganizerStatus } from '../lib/supabase';
import { organizerPermissions } from '../helpers';

// Bottone "Crea una serata" con il controllo dei permessi incorporato.
// Chi non e' abilitato non vede il bottone ma la richiesta di abilitazione.
// Usato sia nella home sia nella pagina Scopri, cosi' le due non possono piu'
// comportarsi in modo diverso.
function CreateEventButton({ currentUser, venues, venueEquipment, onCreateEvent,
  label = "Crea una serata", className = "btn btn-teal", style = {} }) {

  const [showCreate, setShowCreate] = useState(false);
  const [showRequest, setShowRequest] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);

  const { canCreatePublic, canCreateAny } = organizerPermissions(currentUser);
  const alreadyRequested = requestSent || currentUser?.requested_organizer;

  const handleRequest = async () => {
    setRequestLoading(true);
    try { await requestOrganizerStatus(); setRequestSent(true); }
    catch (e) { console.error(e); }
    finally { setRequestLoading(false); }
  };

  if (!canCreateAny) return (
    <div style={style}>
      <button className="btn btn-secondary" style={{ width: "100%", justifyContent: "center" }}
        onClick={() => setShowRequest(true)}>
        Vuoi organizzare una serata?
      </button>
      <div style={{ fontSize: 16, color: "var(--muted)", textAlign: "center", marginTop: 6 }}>
        Non sei ancora abilitato a organizzare serate.
      </div>
      {showRequest && (
        <Modal onClose={() => setShowRequest(false)} maxWidth={360}>
          <div className="modal-title">Organizzare una serata</div>
          {alreadyRequested ? (
            <>
              <div style={{ fontSize: 17, color: "var(--muted)", marginBottom: 20, lineHeight: 1.6 }}>
                La tua richiesta e' stata inviata. L'admin ti abilitera' al piu' presto.
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRequest(false)}>Chiudi</button>
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 17, color: "var(--muted)", marginBottom: 20, lineHeight: 1.6 }}>
                Non sei ancora abilitato a organizzare serate.<br /><br />
                Vuoi inviare una richiesta all'admin? Ti abilitera' al piu' presto.
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRequest(false)}>Annulla</button>
                <button className="btn btn-primary" disabled={requestLoading} onClick={handleRequest}>
                  {requestLoading ? <span className="spinner" /> : "Invia richiesta"}
                </button>
              </div>
            </>
          )}
        </Modal>
      )}
    </div>
  );

  return (
    <div style={style}>
      <button className={className} style={{ width: "100%", justifyContent: "center" }}
        onClick={() => setShowCreate(true)}>
        {label}
      </button>
      {showCreate && (
        <EventModal
          venues={venues} venueEquipment={venueEquipment || {}}
          canCreatePublic={canCreatePublic}
          onClose={() => setShowCreate(false)}
          onSave={async (data, eq) => { await onCreateEvent(data, eq); setShowCreate(false); }} />
      )}
    </div>
  );
}

export default CreateEventButton;
